import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CalendarEventScope } from "../_types/calendar-event-scope";

@Injectable({
    providedIn: 'root',
})

export class CalendarsEventsScopesService extends Service<CalendarEventScope> {
  public override type = 'calendarEventScopes';
  public override url = 'providers/calendarEventScopes';
}
